export class TokenManager {
    public static getUID(): number | null {
        return parseInt(localStorage.getItem("uid"))
    }

    public static setUID(token: number | null) {
        if (token != null) localStorage.setItem("uid", "" + token)
        else localStorage.removeItem("uid")
    }

    public static getToken(): string | null {
        return localStorage.getItem("token")
    }

    public static setToken(token: string | null) {
        if (token != null) localStorage.setItem("token", token)
        else localStorage.removeItem("token")
    }
}
